import { BaseService } from 'core/services';
import FacilityRouteService from './FacilityRouteService';

class FacilityService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityRouteService());
    }

    async sync(){
        const url = this.routeService.sync();
        const response = await this.apiClient.put(url);
        return response.data || null;
    }

    syncNiko(){
        const url = this.routeService.syncNiko();
        return this.apiClient.put(url);
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }
 
    getDownloadESignUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadESign(filter);
    }

    getDownloadContactsUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadContacts(filter);
    }

    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);  
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }

    bulkUpdate(resources) {
        const url = this.routeService.bulkUpdate(resources);
        return this.apiClient.put(url, resources)
    }
    updatePumpsNote(resource) {
		const url = this.routeService.updatePumpsNote(resource);
		return this.apiClient.put(url, resource);
	} 

    syncAddress(resource){
        const url = this.routeService.syncAddress(resource);
		return this.apiClient.put(url, resource);
    }

    hasNikoDeliveryLocation(id) {
        const url = this.routeService.hasNikoDeliveryLocation(id);
        return this.apiClient.get(url);
    }

    syncAndValidatePayers(id) {
        const url = this.routeService.syncAndValidatePayers(id);
        return this.apiClient.put(url);
    }
}

export default FacilityService;
